import { PureComponent } from "react";
import { Box, Text } from "@chakra-ui/react";
import { PieChart, Pie, Legend, ResponsiveContainer, Cell } from "recharts";

class AllTicketsPieGraph extends PureComponent {
  render() {
    const { chart, chartHeight } = this.props;

    const data = [
      { name: "Completed", value: chart.completed },
      { name: "No Show", value: chart.noShow },
      { name: "Unattended", value: chart.unattended },
    ];
    
    const COLORS = ["#188038", "#d93025", "#d99125"]; // green, red, orange

    return (
      <Box width="100%" h={chartHeight}>
        {chart.completed === 0 &&
        chart.noShow === 0 &&
        chart.unattended === 0 ? (
          <Box mt="70px">
            <Text align="center" color="#535353">
              No data available for this Pie Chart
            </Text>
          </Box>
        ) : (
          <>
            <ResponsiveContainer>
              <PieChart width={400} height={300} isAnimationActive={false}>
                <Pie
                  dataKey="value"
                  startAngle={0}
                  endAngle={360}
                  data={data}
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  innerRadius={45}
                  label
                  animationDuration={0}
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Legend verticalAlign="bottom" width="100%" />
              </PieChart>
            </ResponsiveContainer>
          </>
        )}
      </Box>
    );
  }
}

export default AllTicketsPieGraph;
